import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

export const fetchTenants = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/tenants`,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching Tenants:", error);
        throw error;
    }
};

export const fetchActiveTenants = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/tenants/active`,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching Tenants:", error);
        throw error;
    }
};

export const addTenant = async (tenantData) => {
    const token = localStorage.getItem("token");

    const name = (tenantData?.name ?? "").trim();
    if (!name) {
        throw new Error("tenant name is required");
    }

    const code = (tenantData?.code ?? "").trim();
    if (!code) {
        throw new Error("tenant code is required");
    }

    const gitProvider = (tenantData?.gitProvider ?? "").trim();
    if (!gitProvider) {
        throw new Error("git provider is required");
    }

    const projectName = (tenantData?.projectName ?? "").trim();
    if (gitProvider !== "GITHUB" && !projectName) {
        throw new Error("project name is required");
    }

    const organizationName = (tenantData?.organizationName ?? "").trim();
    if (!organizationName) {
        throw new Error("organization name is required");
    }

    const awsAccountId = (tenantData?.awsAccountId ?? "").trim();
    if (!awsAccountId) {
        throw new Error("AWS account ID is required");
    }

    const awsRegion = (tenantData?.awsRegion ?? "").trim();
    if (!awsRegion) {
        throw new Error("AWS region is required");
    }

    const apiVersion = (tenantData?.apiVersion ?? "").trim();
    if (gitProvider !== "AZURE" && !apiVersion) {
        throw new Error("api version is required");
    }

    const payload = {
        name: name,
        code: code,
        gitProvider: gitProvider.toUpperCase(),
        projectName: gitProvider.toUpperCase() === "GITHUB" ? null : projectName,
        organizationName: organizationName,
        //         gitDirectoryPath: "/tmp/repositories/",
        awsAccountId: awsAccountId,
        awsRegion: awsRegion,
        apiVersion: gitProvider.toUpperCase() === "AZURE" ? null : apiVersion,
    };

    const res = await axios.post(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/tenants`,
        payload,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const updateTenant = async (tenantId, updatedData) => {
    const token = localStorage.getItem("token");

    const res = await axios.patch(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/tenants/${encodeURIComponent(tenantId)}`,
        updatedData,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const updateTenantStatus = async (tenantId, status) => {
    const token = localStorage.getItem("token");

    const statusValue = status === true || status === "true";

    const payload = { isActive: statusValue };

    const res = await axios.patch(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/tenants/${encodeURIComponent(tenantId)}/status`,
        payload,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const deleteTenant = async (tenantId) => {
    const token = localStorage.getItem("token");

    const res = await axios.delete(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/tenants/${encodeURIComponent(tenantId)}`,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return res?.data ?? null;
};
